


import * as signalR from "@microsoft/signalr";

const apiUrl = process.env.REACT_APP_API_URL;
let startPromise: Promise<void> | null = null;

export const connection = new signalR.HubConnectionBuilder()
    .withUrl(`${apiUrl}/orderHub`, { withCredentials: true })
    .withAutomaticReconnect()
    .build();

export async function startConnection() {
    if (connection.state === signalR.HubConnectionState.Connected)
        return;
    if (!startPromise) {
        startPromise = connection.start().finally(() => {
            startPromise = null;
        });
    }
    await startPromise;
}

export async function stop() {
    await connection.stop();
}